<div class="flex flex-col h-full">
    <div *ngIf="!authenticated">
        <app-header class=""></app-header>
    </div>
    <div *ngIf="authenticated">
        <app-private-header class=""></app-private-header>
    </div>
    <div class="flex justify-center bg-gradient-b-light-gray flex-grow flex-shrink-0 bg-beige-tricon p-6 sm:p-8">
        <router-outlet></router-outlet>
    </div>
    <div class="flex flex-shrink-0 items-center justify-center bg-true-blue">
        <app-footer class="w-full text-white"></app-footer>
    </div>
</div>
